import { render } from "./ComponenteSimulaciones.vue?vue&type=template&id=f50d1c24&scoped=true"
import script from "./ComponenteSimulaciones.vue?vue&type=script&lang=js"
export * from "./ComponenteSimulaciones.vue?vue&type=script&lang=js"

import "./ComponenteSimulaciones.vue?vue&type=style&index=0&id=f50d1c24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f50d1c24"]])

export default __exports__